// ============================================================
// THE COMPANY — StatusSelect Component
// ============================================================

import { useCompanyStore } from '../../store/useCompanyStore';
import { STATUS_COLORS, STATUS_LABELS, DEFAULT_STATUSES } from '../../lib/constants';
import type { Role, RoleStatus } from '../../lib/types';

interface StatusSelectProps {
  role: Role;
}

export default function StatusSelect({ role }: StatusSelectProps) {
  const updateRole = useCompanyStore((s) => s.updateRole);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value as RoleStatus;
    updateRole(role.id, { status: newStatus });
  };

  return (
    <div className="relative">
      <label className="block text-xs font-medium mb-1.5" style={{ color: 'var(--text-muted)' }}>
        Status
      </label>
      <div className="relative">
        {/* Color dot inside the select area */}
        <span
          className="absolute left-3 top-1/2 -translate-y-1/2 h-2.5 w-2.5 rounded-full pointer-events-none"
          style={{ backgroundColor: STATUS_COLORS[role.status] }}
        />
        <select
          value={role.status}
          onChange={handleChange}
          className="w-full appearance-none rounded-lg pl-8 pr-8 py-2 text-sm font-medium cursor-pointer outline-none transition-colors duration-150"
          style={{
            backgroundColor: 'var(--bg-elevated)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-default)',
          }}
        >
          {DEFAULT_STATUSES.map((status) => (
            <option key={status} value={status}>
              {STATUS_LABELS[status]}
            </option>
          ))}
        </select>
        {/* Dropdown chevron */}
        <svg
          className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          style={{ color: 'var(--text-muted)' }}
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}
